// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.design-modal-button-container[data-v-ea30765a] {\r\n    margin-bottom: 20px;\r\n    text-align: right;\n}\n.design-modal-button-button[data-v-ea30765a] {\r\n    border-bottom: 1px solid #4d4d4d;\r\n    color: #4d4d4d;\r\n    cursor: pointer;\r\n    display: inline-block;\r\n    font-size: 10px;\r\n    font-weight: 600;\r\n    text-transform: uppercase;\n}\r\n", ""]);
// Exports
module.exports = exports;
